import React from "react";
import { css } from "glamor";
import gql from "graphql-tag";
import { Query } from "react-apollo";

import Button from "@arachnys/styleguide/Button";
import { withApolloState } from "../../../util/apollo";

const style = {
    button: css({
        float: "right",
        margin: "10px 0px 30px 10px",
    }),
};

export const RELATION_BUTTON_QUERY = gql`
    query ButtonContainer_AddRelationButton_Query {
        clientConfig {
            hooks(hookType: 7) {
                label
                link
            }
        }
    }
`;

const ButtonContainer = ({ onClick }) => {
    return (
        <Query query={RELATION_BUTTON_QUERY}>
            {withApolloState(({ data }) => {
                if (!data.clientConfig.hooks.length) {
                    return null;
                }

                return (
                    <Button.Primary
                        size="large"
                        icon="link"
                        onClick={event =>
                            onClick(event, data.clientConfig.hooks[0])
                        }
                        {...style.button}
                    >
                        {data.clientConfig.hooks[0].label}
                    </Button.Primary>
                );
            })}
        </Query>
    );
};

export default ButtonContainer;
